function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToggleDuration = exports.Toggle = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _reactNative = require("react-native-web");
var _styles = require("./styles");
var _utils = require("../../utils");
var _styles2 = require("../../styles");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["value", "onChange", "falseLabel", "trueLabel", "accessibilityLabel", "disabled"];
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var ToggleDuration = exports.ToggleDuration = 200;
var Toggle = exports.Toggle = (0, _react.memo)(function (_ref) {
  var value = _ref.value,
    onChange = _ref.onChange,
    falseLabel = _ref.falseLabel,
    trueLabel = _ref.trueLabel,
    accessibilityLabel = _ref.accessibilityLabel,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useStyles = (0, _styles.useStyles)(),
    styles = _useStyles.styles;
  var _buttonRef = (0, _react.useRef)(null);
  var _thumbPosition = (0, _react.useRef)(new _reactNative.Animated.Value(+value)).current;
  var _hasLabel = !!falseLabel && !!trueLabel;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    _isFocused = _useState2[0],
    _setIsFocused = _useState2[1];
  var _onFocus = function _onFocus() {
    return _setIsFocused(true);
  };
  var _onBlur = function _onBlur() {
    return _setIsFocused(false);
  };
  var _onChange = function _onChange(newValue) {
    _reactNative.Animated.timing(_thumbPosition, {
      toValue: +newValue,
      duration: ToggleDuration,
      useNativeDriver: _utils.useNativeDriver
    }).start(function () {
      var _buttonRef$current;
      (_buttonRef$current = _buttonRef.current) == null ? void 0 : _buttonRef$current.setAttribute('aria-checked', String(newValue));
      onChange == null ? void 0 : onChange(newValue);
    });
  };
  var _onPress = function _onPress() {
    _onChange(!value);
  };
  var _onKeyUp = function _onKeyUp(event) {
    if (event.code === 'Space') {
      event.preventDefault();
      _onChange(!value);
    }
  };
  return (0, _jsxRuntime.jsx)(_reactNative.View, Object.assign({}, props, {
    children: (0, _jsxRuntime.jsxs)(_reactNative.View, {
      style: [styles.row, disabled && styles.disabled],
      testID: "Toggle",
      children: [_reactNative.Platform.OS === 'web' ? (0, _jsxRuntime.jsx)("button", {
        ref: _buttonRef,
        style: _reactNative.StyleSheet.flatten([styles.button, _isFocused && styles.button_focused]),
        role: "switch",
        "aria-label": accessibilityLabel,
        "aria-checked": value,
        disabled: disabled,
        onClick: _onPress,
        onFocus: _onFocus,
        onBlur: _onBlur,
        onKeyUp: _onKeyUp,
        type: "button"
      }) : (0, _jsxRuntime.jsx)(_reactNative.TouchableOpacity, {
        style: [styles.button, _isFocused && styles.button_focused],
        accessibilityRole: "switch",
        accessibilityLabel: accessibilityLabel,
        accessibilityHint: value ? falseLabel : trueLabel,
        accessibilityState: {
          checked: value,
          disabled: disabled
        },
        onPress: _onPress,
        disabled: disabled
      }), _hasLabel && (0, _jsxRuntime.jsx)(_reactNative.Text, {
        textBreakStrategy: "simple",
        style: value ? styles.text : styles.activeText,
        children: falseLabel
      }), (0, _jsxRuntime.jsx)(_reactNative.View, {
        style: styles.touchableArea,
        children: (0, _jsxRuntime.jsx)(_reactNative.View, {
          style: styles.gutter,
          children: (0, _jsxRuntime.jsx)(_reactNative.Animated.View, {
            style: [styles.thumb, {
              transform: [{
                translateX: _thumbPosition.interpolate({
                  inputRange: [0, 1],
                  outputRange: [(0, _styles2.getREM)(0), (0, _styles2.getREM)(1.5625)]
                })
              }]
            }]
          })
        })
      }), _hasLabel && (0, _jsxRuntime.jsx)(_reactNative.Text, {
        textBreakStrategy: "simple",
        style: value ? styles.activeText : styles.text,
        children: trueLabel
      })]
    })
  }));
});